// with es6
import React, { Component } from "react";
import decode from "jwt-decode";
//import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
// import moment from 'moment'
import { Button, Row, Col, Card, CardBody } from "mdbreact";
//import 'node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import axios from "axios";
import { Link } from "react-router-dom";

import domain from ".././../../../domain";

function dateFormatter(cell) {
  let s = new Date(cell);

  return `${("0" + s.getDate()).slice(-2)}/${("0" + (s.getMonth() + 1)).slice(
    -2
  )}/${s.getFullYear()}`;
}

export default class AddSchedule extends Component {
  constructor() {
    super();
    this.state = {
      courses: [],
      sessions: [],
      id: "",
      username: "",
    };
  }

  componentDidMount() {
    this.getCourses();
    this.getSessions();

    const { id, username } = decode(localStorage.getItem("token"));
    console.log(id);
    this.setState({
      id: id,
      username: username,
    });
  }
  statusFormatter(cell, row, enumObject, index) {
    return <div>{index + 1}</div>;
  }
  // buttonFormatter=(row)=>{
  //     if(this.state.sessions)
  //     {
  //           return (<ViewScheduleModal row={row} schedule={this.state.sessions}/>);
  //     }
  // }

  getSessions() {
    axios
      .get(`${domain.DBServer}/fetch-sessions`)
      .then((response) => {
        console.log(response.data);
        this.setState({ sessions: response.data }, () => {});
      })
      .catch((err) => console.log(err));
  }

  getCourses() {
    axios
      .get(`${domain.DBServer}/fetch-course-participants`)
      .then((response) => {
        console.log(response.data);
        this.setState({ courses: response.data }, () => {});
      })
      .catch((err) => console.log(err));
  }

  render() {
    const courses = this.state.courses;

    let coursetable;

    if (courses) {
      //  console.log(courses)
      coursetable = courses.map((course, key) => {
        let category;
        switch (parseInt(course.cat_id, 10)) {
          case 1:
            category = "One Week";
            break;
          case 2:
            category = "Two Week";
            break;
          case 3:
            category = "Customized";
            break;
          default:
            category = null;
        }

        return (
          <tr key={key}>
            {/* {console.log(course.course_id)} */}
            <th scope="row">{key + 1}</th>
            <td>{course.course_id}</td>
            <td>{course.year}</td>
            <td>{course.title}</td>
            <td>{category}</td>
            <td>{dateFormatter(course.start_date)}</td>
            <td>{dateFormatter(course.end_date)}</td>
            <td>{course.status}</td>

            <td style={{ textAlign: "center" }}>
              {course.status === "Completed" ? (
                <Button disabled color="primary">
                  + Add
                </Button>
              ) : (
                <Link to={`/add-schedule/${course.course_id}`}>
                  <Button color="primary">+ Add</Button>
                </Link>
              )}
            </td>
          </tr>
        );
      });
    }
    return (
      <Row className="justify-content-md-center">
        <Col md="12">
          <Card>
            {/* <h3 style={{color:"#3f51b5",textAlign:"left", paddingLeft:"20px", paddingTop:"10px"}}>Welcome {this.state.username}</h3> */}
            <CardBody>
              <table
                className="table table-striped table-bordered table-responsive-md"
                cellSpacing="0"
                width="100%"
              >
                <thead
                  style={{ textAlign: "center", backgroundColor: "#33b5e5" }}
                >
                  <tr>
                    <th scope="col">S. No</th>
                    <th scope="col">Course ID</th>
                    <th scope="col">Year</th>
                    <th scope="col">Title of the Course</th>
                    <th scope="col">Category</th>
                    <th scope="col">Start Date</th>
                    <th scope="col">End Date</th>
                    <th scope="col">Status</th>

                    <th scope="col">Add Schedule</th>
                  </tr>
                </thead>
                <tbody>{coursetable}</tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}
